import Unsplash from './components/UnsplashAssetSource'
import Icon from './components/Icon'

export default {
  name: 'unsplash',
  title: 'Unsplash',
  component: Unsplash,
  icon: Icon
}
